import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=21f07781&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Add.vue?vue&type=style&index=1&id=21f07781&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f07781",
  null
  
)

export default component.exports